export enum RoutePath {
  Dashboard = "/",
  HedgeBeaconAnalysis = "/analyst/recommendation",
  HedgeBeaconAlert = "/analyst/alert",
  HedgeBeaconMarketThoughts = "/analyst/market_thoughts",
  HedgeBeaconEmailPreview = "/analyst/email/preview",
  TicketsWeightDashboard = "/weight/tickets/dashboard",
  TicketsTradingDashboard = "/trading/tickets/dashboard",
  TicketsUpload = "/tickets/upload",
  SalesAndPurchaseReports = "/tickets/freight",
  DormanStagedDashboard = "/tickets/dorman/staged",
  MarketingTransactionalReport = "/reports/marketing",
  SpreadReport = "/reports/spread",
  ARReport = "/reports/ar",
  TicketsJobsDashboard = "/tickets/jobs",
  TradingBacktest = "/trading/backtest",
  TradingAtsData = "/trading/ats/dashboard",
  TradingAtsLive = "/trading/ats/live",
  QueuedDocuments = "/document/queue",
  DeveloperDashboard = "/developer/dashboard",
  DeveloperJobsDashboard = "/developer/jobs/dashboard",
  DeveloperTestPage = "/developer/test",
  DeveloperClientNotifications = "/developer/client/notifications",
  MobileClientUsers = "/mobile/client/users",
  MobileResources = "/mobile/client/resources",
  Authenticate = "/authenticate",
  Login = "/login",
  ManageCustomers = "/ManageCustomers",
  LocationDashboard = "/location",
  CostBasisDashboard = "/costs_basis",
  CallLogsDashboard = "/call_logs",
  VideoDashboard = "/video/splicing",
  HedgeBeaconSplicing = "/video/hedgebeacon/splicing",
  ContactsDashboard = "/contacts",
  MarketZoneDashboard = "/marketZone",
  ContractsDashboard = "/contracts",
  ContractsGeneralDashboard = "/contracts/general",
  ContractsOtcDashboard = "/contracts/otc",
  ContractsLanguageGeneralDashboard = "/contracts/language/general",
  ContractsLanguageOtcDashboard = "/contracts/language/otc",
  GeneralContractsDashboard = "/general/contracts",
  GeneralContractSettingsDashboard = "/general/contracts/settings",
  StagedGeneralContractsDashboard = "/general/contracts/staged",
  AgtechContractsDashboard = "/agtech/contracts",
  ContractQuantityAlertDashboard = "/contract/quantity/alert",
  ManageTraders = "/ManageTraders",
  CogsReports = "/cogs",
  OtcDashboard = "/otc",
  PositionsDashboard = "/trading/positions",
  DestinationMessagingDashboard = "/destination/messaging",
  DestinationHoursDashboard = "/destination/hours",
  DestinationHoursImprovedDashboard = "/destination-hours",
  DestinationMessagingConsentScreenshot = "/destination-consent-screenshot",
  DestinationMessagingConsent = "/destination-consent",
  NewsArticles = "/news/articles",
  ManagePermissions = "/permissions/manage",
  MobilePermissions = "/permissions/mobile",
  MobilePermissionsClient = "/permissions/mobile/client",
  MobilePermissionsFreight = "/permissions/mobile/freight",
  MobilePermissionsUserDetail = "/permissions/mobile/:userId",
  InvoiceAndStatementReport = "/reports/invoices",
  PrivacyPolicy = "/privacy-policy",
  DeferredPayments = "/payments/deferred",
  Chat = "/chats",
  TaskChecklists = "/task/checklists",
  KnowledgeTasks = "/tasks",
  KnowledgeTaskDetail = "/tasks/:taskId",
  KnowledgeTaskCreate = "/tasks/create",
  KnowledgeTaskEdit = "/tasks/:taskId/edit",
  ManualPriceData = "/price-data/manual",
  DirectSales = "/direct-sales",
  Settings = "/settings",
  GrainSamplesDashboard = "/grain/samples",
  GrainPositionsDashboard = "/grain/positions",
  RiskManagement = "/risk/management",
  RiskManagementCashSales = "/risk/management/cashSales",
  RiskManagementCropProfiles = "/risk/management/profiles",
  RiskManagementSummary = "/risk/management/summary",
  RiskManagementFull = "/risk/full",
  RiskManagementFullBrokerage = "/risk/full/brokerage",
  RiskManagementFullBrokerageOpenOrders = "/risk/full/brokerage/open-orders",
  RiskManagementFullBrokeragePAndS = "/risk/full/brokerage/p-and-s",
  TTOrders = "/risk/full/brokerage/tt-orders",
  TTOrdersDashboard = "/risk/full/brokerage/tt-orders/dashboard",
  TTOrdersDetail = "/risk/full/brokerage/tt-orders/dashboard/order/:guid_order_id",
  RiskManagementSalesNotes = "/risk/activities/sales-notes",
  RiskManagementRecommendations = "/risk/recommendations",
  RiskMarketZone = "/risk/market-zone",
  BirthdayFund = "/fund/birthday",
  BeaconFund = "/fund/beacon",
  GFReport = "/reports/gf",
  OtcPrem = "/reports/otcPrem",
  ContractMTM = "/reports/contracts/mtm",
  McCluskyFeeAccrual = "/reports/mccluskyFeeAccrual",
  Brokerage = "/brokerage",
  ExportSalesTracker = "/reports/export_sales_tracker",
  CfrDocuments = "/contracts/cfr",
  CfrDocumentsReports = "/contracts/cfr/reports",
  CfrDocumentsTemplates = "/contracts/cfr/templates",
  CfrDocumentsTemplatesCreate = "/contracts/cfr/templates/create",
  CfrDocumentsTemplatesView = "/contracts/cfr/templates/:templateId/view",
  CfrDocumentsInstances = "/contracts/cfr/instances",
  CfrDocumentsInstanceSentPreview = "/contracts/cfr/templates/:templateId/instances/:instanceId/sent",
  CfrDocumentsInstanceFinalPreview = "/contracts/cfr/templates/:templateId/instances/:instanceId/final",
  Agtech = "/agtech/",
  AgtechReports = "/agtech/reports",
  AchDocuments = "/contracts/ach",
  AchDocumentsTemplates = "/contracts/ach/templates",
  AchDocumentsTemplatesCreate = "/contracts/ach/templates/create",
  AchDocumentsTemplatesView = "/contracts/ach/template/:template_id",
  AchDocumentsInstanceSentPreview = "/contracts/ach/templates/:templateId/instances/:instanceId/sent",
  AchDocumentsInstanceFinalPreview = "/contracts/ach/templates/:templateId/instances/:instanceId/final",
  MarketSimilarity = "/market_similarity",
  AchDocumentsReviewInstances = "/contracts/ach/review-instances",
  DestinationPackets = "/contracts/destination_packets",
  DestinationPacketsTemplates = "/contracts/destination_packets/templates",
  DestinationPacketsTemplatesCreate = "/contracts/destination_packets/templates/create",
  DestinationPacketsTemplatesView = "/contracts/destination_packets/template/:template_id",
  DestinationPacketsTemplatesPreview = "/contracts/destination_packets/template/:template_id/preview",
  DestinationPacketsSendEnvelope = "/contracts/destination_packets/send-envelope",
  DestinationPacketsInstances = "/contracts/destination_packets/instances",
  DestinationPacketsInstanceSentPreview = "/contracts/destination_packets/template/:template_id/instances/:instance_id/sent",
  DestinationPacketsInstanceFinalPreview = "/contracts/destination_packets/template/:template_id/instances/:instance_id/final",
  FreightDashboard = "/freight",
  FreightImagesDashboard = "/freight/images",
}
